<template>
  <div class="privacy-page">
    <div class="page-header parallaxie">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-12">
            <!-- Page Header Box Start -->
            <div class="page-header-box">
              <h1 class="wow fadeInUp" data-cursor="-opaque">Política de Privacidad</h1>
              <nav class="wow fadeInUp" data-wow-delay="0.2s">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item active" aria-current="page">
                    Lea atentamente nuestra política de privacidad antes de utilizar nuestro sitio web y servicios.
                  </li>
                </ol>
              </nav>
            </div>
            <!-- Page Header Box End -->
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <!-- Section Title Start -->
      <div class="section-title section-title-center">
        <p class="wow fadeInUp" data-wow-delay="0.2s">
          En <strong>MAP Tecnología y Seguridad</strong> nos tomamos muy en serio la privacidad de nuestros usuarios y clientes.
        </p>
      </div>
      <!-- Section Title End -->

      <!-- Privacy Content Start -->
      <div class="privacy-content wow fadeInUp" data-wow-delay="0.4s">
        <h4>1. Información que recopilamos</h4>
        <p>Podemos recopilar información personal como nombre, correo electrónico, número de teléfono y datos relacionados con el uso de nuestros servicios, únicamente cuando usted nos los proporciona voluntariamente.</p>

        <h4>2. Uso de la información</h4>
        <p>La información recopilada se utiliza para ofrecer y mejorar nuestros servicios, responder a consultas, enviar información relevante y garantizar la seguridad de nuestros clientes.</p>

        <h4>3. Protección de la información</h4>
        <p>Implementamos medidas de seguridad técnicas y organizativas para proteger sus datos personales frente a pérdida, acceso no autorizado o divulgación indebida.</p>

        <h4>4. Compartir información con terceros</h4>
        <p>No compartimos su información personal con terceros, salvo que sea necesario para cumplir con obligaciones legales, procesar pagos o prestar los servicios solicitados.</p>

        <h4>5. Cookies y tecnologías similares</h4>
        <p>Podemos utilizar cookies u otras tecnologías para mejorar la experiencia en nuestro sitio web. Usted puede configurar su navegador para rechazarlas si lo desea.</p>

        <h4>6. Derechos del usuario</h4>
        <p>Usted tiene derecho a acceder, corregir, eliminar o limitar el uso de sus datos personales. Para ejercer estos derechos, puede contactarnos a través del correo electrónico proporcionado abajo.</p>

        <h4>7. Cambios a la política de privacidad</h4>
        <p>Nos reservamos el derecho de modificar esta política en cualquier momento. Cualquier cambio será publicado en nuestro sitio web, por lo que recomendamos revisarla periódicamente.</p>

        <h4>Contacto</h4>
        <p>Para consultas o solicitudes relacionadas con su información personal, puede escribirnos a: 
          <a href="mailto:ventas@mapseguridadmx.com">ventas@mapseguridadmx.com</a>
        </p>
      </div>
      <!-- Privacy Content End -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Politics"
};
</script>
